import { render, staticRenderFns } from "./EmployeesByDepartmentBarChart.vue?vue&type=template&id=196e175a&"
import script from "./EmployeesByDepartmentBarChart.vue?vue&type=script&lang=js&"
export * from "./EmployeesByDepartmentBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports